import intermind from '../../../index';
import { HandRaisedParticipant } from '../types/participant.types';

export class RaisedHandResource {
  async list(conferenceId: string): Promise<HandRaisedParticipant[]> {
    const { data } = await intermind.httpClient.get<HandRaisedParticipant[]>(
      `/conferences/${conferenceId}/raised-hands`
    );
    return data;
  }

  async update(conferenceId: string, participantId: string, isRaised: boolean): Promise<void> {
    if (isRaised) {
      await intermind.httpClient.post(`/conferences/${conferenceId}/raised-hands`, { participantId });
    } else {
      await intermind.httpClient.delete(`/conferences/${conferenceId}/raised-hands/${participantId}`);
    }
  }
}
